<div class="hr-layout">
  <!-- <app-hygine-sidebar></app-hygine-sidebar> -->
  <div class="hr-main-content">
    <div class="hr-report-panel hdw-report-shell">
      <div class="hr-page-outer">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="hr-page-wrap hdw-page-flex">
                <div class="hdw-page-fixed">
                  <div class="hdw-page-head">
                    <div class="hdw-header-top">
                      <h1 class="hr-main-title">Hygiene Day Wise Report</h1>
                      <div class="hr-segment-groups" role="group" aria-label="Filters">
                        <!-- <div class="hr-segment-pair" aria-label="School or College">
                        <button type="button" class="hr-segment-btn" [class.hr-segment-active]="collegeTypes.includes('SCHOOL')"
                          (click)="toggleCollegeType('SCHOOL')">School</button>
                        <button type="button" class="hr-segment-btn" [class.hr-segment-active]="collegeTypes.includes('COLLEGE')"
                          (click)="toggleCollegeType('COLLEGE')">College</button>
                      </div> -->
                        <!-- <span class="hr-segment-divider" aria-hidden="true"></span> -->
                        <!-- <div class="hr-segment-pair" aria-label="Residential or DayScholar">
                        <button type="button" class="hr-segment-btn" [class.hr-segment-active]="boardingTypes.includes('RESIDENTIAL')"
                          (click)="toggleBoarding('RESIDENTIAL')">Residential</button>
                        <button type="button" class="hr-segment-btn" [class.hr-segment-active]="boardingTypes.includes('DAY_SCHOLAR')"
                          (click)="toggleBoarding('DAY_SCHOLAR')">DayScholar</button>
                      </div>
                      <span class="hr-segment-divider" aria-hidden="true"></span> -->
                        <button type="button" class="hr-segment-btn hdw-filter-toggle" (click)="openFilterDialog()">
                          <i class="fa fa-filter" aria-hidden="true"></i> Filter
                        </button>
                      </div>
                    </div>
                    <div class="hr-filter-bar-wrapper hdw-filter-bar" *ngIf="filtersOpen">
                      <!-- Vendor (GET apiV2/vendorList → vendorId on Search) -->
                      <!-- <div class="hr-combobox hr-combobox-vendor">
                      <div class="hr-combobox-trigger" (click)="openVendor()" [class.hr-trigger-open]="vendorOpen">
                        <span class="hr-trigger-text">{{ vendorTriggerText }}</span>
                        <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                      </div>
                      <div class="hr-combobox-panel" *ngIf="vendorOpen">
                        <div class="att-search-container">
                          <input
                            type="text"
                            class="form-control att-search-input"
                            placeholder="Search vendor"
                            [(ngModel)]="vendorQuery"
                            (keyup)="filterVendors()"
                            (mousedown)="$event.stopPropagation()"
                          />
                        </div>
                        <div class="list_campus">
                          <p *ngIf="vendorsError" class="hdw-vendor-inline-msg">{{ vendorsError }}</p>
                          <ul
                            class="att-dropdown-item"
                            (mousedown)="selectVendorClear(); $event.preventDefault()"
                            [class.att-item-selected]="selectedVendorId == null"
                          >
                            <li class="att-item-text">All vendors</li>
                            <li><i *ngIf="selectedVendorId == null" class="fa fa-check att-check-icon"></i></li>
                          </ul>
                          <ng-container *ngFor="let v of filteredVendorList">
                            <ul
                              class="att-dropdown-item"
                              (mousedown)="selectVendor(v); $event.preventDefault()"
                              [class.att-item-selected]="selectedVendorId === v.vendorId"
                            >
                              <li class="att-item-text">{{ v.vendorName }}</li>
                              <li><i *ngIf="selectedVendorId === v.vendorId" class="fa fa-check att-check-icon"></i></li>
                            </ul>
                          </ng-container>
                          <p *ngIf="!vendorsError && !vendorsLoading && vendors.length === 0" class="hdw-vendor-inline-msg">
                            No vendors returned.
                          </p>
                        </div>
                      </div>
                    </div> -->

                      <!-- <span class="hr-filter-sep"></span> -->

                      <!-- State: empty = all states (API); “All states” row checks every id; row checkmarks only when all ids selected -->
                      <div class="hr-combobox">
                        <div class="hr-combobox-trigger" (click)="openState()" [class.hr-trigger-open]="stateOpen"
                          [attr.title]="stateTriggerText">
                          <span class="hr-trigger-text">{{ stateTriggerText }}</span>
                          <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                        </div>
                        <div class="hr-combobox-panel hdw-panel-multiselect" *ngIf="stateOpen"
                          (mousedown)="$event.stopPropagation()">
                          <div class="att-search-container">
                            <input type="text" class="form-control att-search-input" placeholder="Search State"
                              [(ngModel)]="stateQuery" (keyup)="filterStates()" (mousedown)="$event.stopPropagation()">
                          </div>
                          <p class="hdw-multiselect-hint">All states (default), or pick individual states</p>
                          <div class="list_campus">
                            <ul class="att-dropdown-item hdw-ms-row"
                              (mousedown)="selectAllStates(); $event.preventDefault()"
                              [class.att-item-selected]="isAllStatesRowChecked()">
                              <li class="hdw-ms-row-inner">
                                <span class="hdw-ms-box" [class.hdw-ms-box-on]="isAllStatesRowChecked()">
                                  <i *ngIf="isAllStatesRowChecked()" class="fa fa-check" aria-hidden="true"></i>
                                </span>
                                <span class="att-item-text">All states</span>
                              </li>
                            </ul>
                            <ng-container *ngFor="let s of filteredStateList">
                              <ul class="att-dropdown-item hdw-ms-row"
                                (mousedown)="toggleState(s); $event.preventDefault()"
                                [class.att-item-selected]="isStateSelected(s)">
                                <li class="hdw-ms-row-inner">
                                  <span class="hdw-ms-box" [class.hdw-ms-box-on]="isStateSelected(s)">
                                    <i *ngIf="isStateSelected(s)" class="fa fa-check" aria-hidden="true"></i>
                                  </span>
                                  <span class="att-item-text">{{ s.stateName ?? s.name ?? s }}</span>
                                </li>
                              </ul>
                            </ng-container>
                          </div>
                        </div>
                      </div>

                      <span class="hr-filter-sep"></span>

                      <!-- City: same pattern as State (empty = all; “All cities” selects every id) -->
                      <div class="hr-combobox">
                        <div class="hr-combobox-trigger" (click)="openCity()" [class.hr-trigger-open]="cityOpen"
                          [attr.title]="cityTriggerText">
                          <span class="hr-trigger-text">{{ cityTriggerText }}</span>
                          <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                        </div>
                        <div class="hr-combobox-panel hdw-panel-multiselect" *ngIf="cityOpen"
                          (mousedown)="$event.stopPropagation()">
                          <div class="att-search-container">
                            <input type="text" class="form-control att-search-input" placeholder="Search City"
                              [(ngModel)]="cityQuery" (keyup)="filterCities()" (mousedown)="$event.stopPropagation()">
                          </div>
                          <p class="hdw-multiselect-hint">All cities (default), or pick individual cities</p>
                          <div class="list_campus">
                            <ul class="att-dropdown-item hdw-ms-row"
                              (mousedown)="selectAllCities(); $event.preventDefault()"
                              [class.att-item-selected]="isAllCitiesRowChecked()">
                              <li class="hdw-ms-row-inner">
                                <span class="hdw-ms-box" [class.hdw-ms-box-on]="isAllCitiesRowChecked()">
                                  <i *ngIf="isAllCitiesRowChecked()" class="fa fa-check" aria-hidden="true"></i>
                                </span>
                                <span class="att-item-text">All cities</span>
                              </li>
                            </ul>
                            <ng-container *ngFor="let c of filteredCityList">
                              <ul class="att-dropdown-item hdw-ms-row"
                                (mousedown)="toggleCity(c); $event.preventDefault()"
                                [class.att-item-selected]="isCitySelected(c)">
                                <li class="hdw-ms-row-inner">
                                  <span class="hdw-ms-box" [class.hdw-ms-box-on]="isCitySelected(c)">
                                    <i *ngIf="isCitySelected(c)" class="fa fa-check" aria-hidden="true"></i>
                                  </span>
                                  <span class="att-item-text">{{ c.cityName ?? c.name ?? c }}</span>
                                </li>
                              </ul>
                            </ng-container>
                          </div>
                        </div>
                      </div>

                      <span class="hr-filter-sep"></span>

                      <!-- Campus: same pattern as State -->
                      <div class="hr-combobox">
                        <div class="hr-combobox-trigger" (click)="openCampus()" [class.hr-trigger-open]="campusOpen"
                          [attr.title]="campusTriggerText">
                          <span class="hr-trigger-text">{{ campusTriggerText }}</span>
                          <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                        </div>
                        <div class="hr-combobox-panel hdw-panel-multiselect" *ngIf="campusOpen"
                          (mousedown)="$event.stopPropagation()">
                          <div class="att-search-container">
                            <input type="text" class="form-control att-search-input" placeholder="Search Campus"
                              [(ngModel)]="campusQuery" (keyup)="filterCampuses()"
                              (mousedown)="$event.stopPropagation()">
                          </div>
                          <p class="hdw-multiselect-hint">All campuses (default), or pick individual campuses</p>
                          <div class="list_campus">
                            <ul class="att-dropdown-item hdw-ms-row"
                              (mousedown)="selectAllCampuses(); $event.preventDefault()"
                              [class.att-item-selected]="isAllCampusesRowChecked()">
                              <li class="hdw-ms-row-inner">
                                <span class="hdw-ms-box" [class.hdw-ms-box-on]="isAllCampusesRowChecked()">
                                  <i *ngIf="isAllCampusesRowChecked()" class="fa fa-check" aria-hidden="true"></i>
                                </span>
                                <span class="att-item-text">All campuses</span>
                              </li>
                            </ul>
                            <ng-container *ngFor="let c of filteredCampusList">
                              <ul class="att-dropdown-item hdw-ms-row"
                                (mousedown)="toggleCampus(c); $event.preventDefault()"
                                [class.att-item-selected]="isCampusSelected(c)">
                                <li class="hdw-ms-row-inner">
                                  <span class="hdw-ms-box" [class.hdw-ms-box-on]="isCampusSelected(c)">
                                    <i *ngIf="isCampusSelected(c)" class="fa fa-check" aria-hidden="true"></i>
                                  </span>
                                  <span class="att-item-text">{{ c.campusName ?? c.name ?? c }}</span>
                                </li>
                              </ul>
                            </ng-container>
                          </div>
                        </div>
                      </div>

                      <span class="hr-filter-sep"></span>

                      <!-- Building: same pattern as State -->
                      <div class="hr-combobox">
                        <div class="hr-combobox-trigger" (click)="openBuilding()"
                          [class.hr-trigger-open]="buildingOpen">
                          <span class="hr-trigger-text hdw-native-tooltip" [attr.title]="vendorTriggerText">{{
                            buildingTriggerText }}</span>
                          <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                        </div>
                        <div class="hr-combobox-panel hdw-panel-multiselect" *ngIf="buildingOpen"
                          (mousedown)="$event.stopPropagation()">
                          <div class="att-search-container">
                            <input type="text" class="form-control att-search-input" placeholder="Search Building"
                              [(ngModel)]="buildingQuery" (keyup)="filterBuildings()"
                              (mousedown)="$event.stopPropagation()">
                          </div>
                          <p class="hdw-multiselect-hint">All buildings (default), or pick individual buildings</p>
                          <div class="list_campus">
                            <ul class="att-dropdown-item hdw-ms-row"
                              (mousedown)="selectAllBuildings(); $event.preventDefault()"
                              [class.att-item-selected]="isAllBuildingsRowChecked()">
                              <li class="hdw-ms-row-inner">
                                <span class="hdw-ms-box" [class.hdw-ms-box-on]="isAllBuildingsRowChecked()">
                                  <i *ngIf="isAllBuildingsRowChecked()" class="fa fa-check" aria-hidden="true"></i>
                                </span>
                                <span class="att-item-text">All buildings</span>
                              </li>
                            </ul>
                            <ng-container *ngFor="let b of filteredBuildingList">
                              <ul class="att-dropdown-item hdw-ms-row"
                                (mousedown)="toggleBuilding(b); $event.preventDefault()"
                                [class.att-item-selected]="isBuildingSelected(b)">
                                <li class="hdw-ms-row-inner">
                                  <span class="hdw-ms-box" [class.hdw-ms-box-on]="isBuildingSelected(b)">
                                    <i *ngIf="isBuildingSelected(b)" class="fa fa-check" aria-hidden="true"></i>
                                  </span>
                                  <span class="att-item-text">{{ b.buildingName ?? b.name ?? b }}</span>
                                </li>
                              </ul>
                            </ng-container>
                          </div>
                        </div>
                      </div>

                      <span class="hr-filter-sep"></span>

                      <!-- Department -->
                      <div class="hr-combobox">
                        <div class="hr-combobox-trigger" (click)="openDepartment()"
                          [class.hr-trigger-open]="departmentOpen" [attr.title]="departmentDisplayText">
                          <span class="hr-trigger-text">{{ departmentDisplayText }}</span>
                          <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                        </div>
                        <div class="hr-combobox-panel" *ngIf="departmentOpen" (mousedown)="$event.stopPropagation()">
                          <div class="list_campus">
                            <ng-container *ngFor="let d of departments">
                              <ul class="att-dropdown-item" (mousedown)="selectDepartment(d); $event.preventDefault()"
                                [class.att-item-selected]="selectedDepartmentId === d.id">
                                <li class="att-item-text">{{ d.name }}</li>
                                <li><i *ngIf="selectedDepartmentId === d.id" class="fa fa-check att-check-icon"></i>
                                </li>
                              </ul>
                            </ng-container>
                          </div>
                        </div>
                      </div>

                      <span class="hr-filter-sep"></span>

                      <!-- Month / Year picker: click year → choose year → choose month -->
                      <div class="hdw-month-wrap hr-combobox">
                        <div class="hr-combobox-trigger hdw-month-picker-trigger"
                          (click)="openMonthPicker(); $event.stopPropagation()"
                          [class.hr-trigger-open]="monthPickerOpen" [attr.title]="monthLabel">
                          <span class="hr-trigger-text">{{ monthLabel }}</span>
                          <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                        </div>
                        <div class="hr-combobox-panel hdw-month-picker-panel" *ngIf="monthPickerOpen"
                          (mousedown)="$event.stopPropagation()">
                          <ng-container *ngIf="!pickerYearView">
                            <div class="hdw-mp-header hdw-mp-header-month">
                              <button type="button" class="hdw-mp-year-nav"
                                (click)="stepPickerYear(-1); $event.stopPropagation()"
                                [disabled]="!canPickerStepYearBack" title="Previous year" aria-label="Previous year">
                                <i class="fa fa-chevron-left"></i>
                              </button>
                              <button type="button" class="hdw-mp-year-title"
                                (click)="showYearPicker(); $event.stopPropagation()" title="Choose year from list">
                                <span class="hdw-mp-year-num">{{ pickerYear }}</span>
                                <i class="fa fa-caret-down hdw-mp-year-caret" aria-hidden="true"></i>
                              </button>
                              <button type="button" class="hdw-mp-year-nav"
                                (click)="stepPickerYear(1); $event.stopPropagation()"
                                [disabled]="!canPickerStepYearForward" title="Next year" aria-label="Next year">
                                <i class="fa fa-chevron-right"></i>
                              </button>
                            </div>
                            <div class="hdw-mp-month-grid">
                              <button *ngFor="let m of monthNamesShort; let i = index" type="button" class="hdw-mp-cell"
                                [class.hdw-mp-cell-disabled]="isMonthDisabledInPicker(i)"
                                [class.hdw-mp-cell-selected]="pickerYear === selectedYear && i === selectedMonthIndex"
                                [disabled]="isMonthDisabledInPicker(i)" (click)="selectMonthFromPicker(i)">{{ m
                                }}</button>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="pickerYearView">
                            <div class="hdw-mp-header hdw-mp-header-year">
                              <button type="button" class="hdw-mp-back" (click)="backToMonthGrid()"
                                aria-label="Back to months">
                                <i class="fa fa-chevron-left"></i>
                              </button>
                              <span class="hdw-mp-header-label">Select year</span>
                            </div>
                            <div class="hdw-mp-year-grid list_campus">
                              <button *ngFor="let y of pickerYearList" type="button" class="hdw-mp-year-cell"
                                [class.hdw-mp-cell-selected]="y === pickerYear" (click)="selectPickerYear(y)">{{ y
                                }}</button>
                            </div>
                          </ng-container>
                          <div class="hdw-mp-footer">
                            <button type="button" class="hdw-mp-link" (click)="pickerClear()">Clear</button>
                            <button type="button" class="hdw-mp-link" (click)="pickerThisMonth()">This month</button>
                          </div>
                        </div>
                      </div>

                      <div class="hr-filter-bar-spacer"></div>
                      <button type="button" class="hr-search-btn" (click)="onSearch()">
                        <i class="fa fa-search"></i> Apply
                      </button>
                    </div>
                  </div>

                  <div class="hdw-subtitle hdw-subtitle-with-nav">
                    <div class="hdw-subtitle-lead"
                      [class.hdw-subtitle-lead--triple]="overallPaidSummaryVisible && hasSpecificVendor">
                      <div class="hdw-subtitle-vendor-chip" *ngIf="hasSpecificVendor">
                        <span class="hdw-overall-paid-label">Vendor</span>
                        <span class="hdw-subtitle-vendor-value hdw-native-tooltip" [attr.title]="vendorTriggerText">{{
                          vendorTriggerText }}</span>
                      </div>
                      <ng-container *ngIf="overallPaidSummaryVisible && hasSpecificVendor">
                        <div class="hdw-overall-paid-chip">
                          <span class="hdw-overall-paid-label">Overall Last Paid Amount</span>
                          <span class="hdw-overall-paid-value">{{ formatPaidAmount(overallAvgPaidAmount) }}</span>
                        </div>
                        <div class="hdw-overall-paid-chip">
                          <span class="hdw-overall-paid-label">Overall Est. Amount</span>
                          <span class="hdw-overall-paid-value">{{ formatPaidAmount(overallEstPaidAmount) }}</span>
                        </div>
                      </ng-container>
                    </div>
                    <div class="hdw-subtitle-nav-cluster">
                      <button type="button" class="hdw-nav-btn" (click)="goMonthBack()" [disabled]="!canGoMonthBack"
                        title="Previous month" aria-label="Previous month">
                        <i class="fa fa-chevron-left"></i>
                      </button>
                      <span class="hdw-subtitle-text">{{ monthLabel }}</span>
                      <button type="button" class="hdw-nav-btn" (click)="goMonthForward()"
                        [disabled]="!canGoMonthForward" title="Next month" aria-label="Next month">
                        <i class="fa fa-chevron-right"></i>
                      </button>
                    </div>
                    <div>
                       <button type="button" class="hr-excel-btn" (click)="exportToExcel()" title="Export to Excel">
                <i class="fa fa-file-excel-o"></i>Hygiene day wise Report
              </button>
                    </div>
                  </div>
                </div>

                <div class="hdw-table-scroll-region">
                  <div class="hdw-table-wrap">
                    <table class="hdw-table">
                      <thead>
                        <tr>
                          <th class="hdw-th hdw-th-sticky-1"><span class="hdw-building-text">BUILDING NAME</span></th>
                          <th class="hdw-th hdw-th-sticky-2"><span class="hdw-building-text">BUILDING CODE</span></th>
                          <th class="hdw-th hdw-th-sticky-3">LAST PAID AMOUNT</th>
                          <th class="hdw-th hdw-th-sticky-4">EST.AMOUNT</th>
                          <th class="hdw-th hdw-th-day-col" *ngFor="let day of dayHeaders" scope="col"
                            [class.hdw-th-today]="isTodayDayHeader(day)" [class.hdw-th-future]="isFutureDayHeader(day)"
                            [attr.title]="dayWiseIsoDate(day)">
                            <span class="hdw-th-day-d">{{ day }}</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="tableRows.length; else hdwNoAttendanceRows">
                          <tr *ngFor="let row of tableRows">
                            <td class="hdw-td hdw-td-sticky-1">
                              <span class="hdw-building-text" [class.hdw-native-tooltip]="rowBuildingVendorTooltip(row)"
                                [class.hdw-building-text--map]="rowHasBuildingMap(row)"
                                [attr.title]="rowBuildingVendorTooltip(row)"
                                [attr.role]="rowHasBuildingMap(row) ? 'button' : null"
                                [attr.tabindex]="rowHasBuildingMap(row) ? 0 : null"
                                (click)="onBuildingNameClick($event, row)"
                                (keydown.enter)="onBuildingNameClick($event, row)"
                                (keydown.space)="onBuildingNameClick($event, row)">{{ row.buildingName }}</span>
                            </td>
                            <td class="hdw-td hdw-td-sticky-2">{{ row.fusionBuildingCodeProd }}
                            </td>
                            <td class="hdw-td hdw-td-sticky-3 hdw-td-money">{{ formatPaidAmount(row.avgPaidAmount) }}
                            </td>
                            <td class="hdw-td hdw-td-sticky-4 hdw-td-money">{{ formatPaidAmount(row.estPaidAmount) }}
                            </td>
                            <td class="hdw-td" *ngFor="let day of dayHeaders"
                              [class.hdw-td-present]="row.dayStatuses[day - 1] === 'PRESENT'"
                              [class.hdw-td-absent]="row.dayStatuses[day - 1] === 'ABSENT'"
                              [class.hdw-td-future]="row.dayStatuses[day - 1] === 'FUTURE'"
                              [class.hdw-td-clickable]="hasCampusContext(row) && !isFutureDayHeader(day)"
                              (click)="onDayCellClick(row, day)"
                              [attr.title]="hasCampusContext(row) && !isFutureDayHeader(day) ? ('View images · ' + dayWiseIsoDate(day)) : null"
                              role="gridcell">
                              <span class="hdw-dot" [class.hdw-dot-present]="row.dayStatuses[day - 1] === 'PRESENT'"
                                [class.hdw-dot-absent]="row.dayStatuses[day - 1] === 'ABSENT'"
                                [class.hdw-dot-future]="row.dayStatuses[day - 1] === 'FUTURE'"></span>
                            </td>
                          </tr>
                        </ng-container>
                        <ng-template #hdwNoAttendanceRows>
                          <tr>
                            <td class="hdw-td hdw-td-empty" [attr.colspan]="3 + dayHeaders.length">No data for this
                              month or filters.</td>
                          </tr>
                        </ng-template>
                      </tbody>
                    </table>
                  </div>

                  <div class="hdw-pagination" *ngIf="attendanceTotalPages > 1 && tableRows.length > 0">
                    <button type="button" class="hdw-page-btn" [disabled]="attendanceCurrentPage <= 1"
                      (click)="setAttendancePage(attendanceCurrentPage - 1)">Previous</button>
                    <ng-container *ngFor="let slot of attendancePaginationSlots">
                      <span *ngIf="slot === 'ellipsis'" class="hdw-page-ellipsis">…</span>
                      <button *ngIf="slot !== 'ellipsis'" type="button" class="hdw-page-num"
                        [class.hdw-page-active]="attendanceCurrentPage === slot" (click)="setAttendancePage(slot)">{{
                        slot }}</button>
                    </ng-container>
                    <button type="button" class="hdw-page-btn"
                      [disabled]="attendanceCurrentPage >= attendanceTotalPages"
                      (click)="setAttendancePage(attendanceCurrentPage + 1)">Next</button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>